import styled from 'styled-components'
// import loginBg from '@/assets/imges/login-bg2.png'
import cubeImg from '@/assets/imges/cube.png'
import { DirectLogin } from './direct-login'
import { ForgetPwd } from './forget-pwd'
import { useEffect, useMemo, useState } from 'react'
import { Dispaths } from '@/types'
import { useGetAuthStatus, useGetLogo } from './util'
import { SubAccount } from '@/pages/login/sub-account'
import { useFavicon, useTitle } from 'ahooks'
import { FirstLogin } from './first-login'
import { FirstReset } from './first-reset-pwd'
import { Spin } from 'antd'
import { SvgIcon } from '@/components'
import { t } from '@/i18n'

type LoginStatus =
  | 'direct-login'
  | 'forget-pwd'
  | 'reset-pwd'
  | 'sub-account'
  | 'first-login'
  | 'first-reset-pwd'
  | 'pwd-expired'

export interface CommonProps {
  setLoginStatus: Dispaths<LoginStatus>
  loginType?: string
}
const bgLoad: React.ReactEventHandler<HTMLDivElement> = e => ((e.target as any).style.opacity = 1)

export interface LogoFilePath {
  file_name?: string
  base64?: string
}

export const getImageSrcFromFilePath = (filePath?: LogoFilePath) => {
  if (!filePath?.file_name || !filePath?.base64) {
    return ''
  }
  const extension = filePath.file_name
    .substring(filePath.file_name.lastIndexOf('.') + 1)
    .toLowerCase()
  const mimeMap: Record<string, string> = {
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    gif: 'image/gif',
    svg: 'image/svg+xml',
    ico: 'image/x-icon',
    bmp: 'image/bmp',
  }
  const mimeType = mimeMap[extension]
  return mimeType ? `data:${mimeType};base64,${filePath.base64}` : ''
}

const Login = () => {
  const [loginStatus, setLoginStatus] = useState<LoginStatus>('direct-login')
  const [active, setActive] = useState('1')
  //页面状态
  const [status, setStatus] = useState<string>('nothing')
  const [oldpassword, setOldpassword] = useState('')
  //获取logo
  const [getLogo, logo] = useGetLogo()
  // 获取授权
  const [authStatus, getAuthStatus] = useGetAuthStatus()
  useTitle(logo?.page_title || '')

  const getoldpassword = val => {
    setOldpassword(val)
  }

  useEffect(() => {
    setStatus('login')
    getLogo().catch(_ => {})
    getAuthStatus()
      .then(res => {
        if (res) {
          if (res?.data?.auth && !res?.data?.expired) {
            return setStatus('login')
          }
          //是否有文件
          if (!res?.data?.auth) {
            return setStatus('auth')
          }
          //机器码是否到期
          if (res?.data?.expired) {
            return setStatus('expired')
          }
        }
        setStatus('nothing')
      })
      .catch(_ => {
        setStatus('nothing')
      })
  }, [])
  // useEffect(() => {
  //   localStorage.setItem('loginType', active === '1' ? 'main-account' : 'sub-account')
  // }, [active])
  const Logo = useMemo(
    () => getImageSrcFromFilePath(logo?.login_logo_file_path),
    [logo?.login_logo_file_path],
  )
  const LoginBg = useMemo(
    () => getImageSrcFromFilePath(logo?.login_bg_file_path),
    [logo?.login_bg_file_path],
  )
  const Favicon = useMemo(
    () => getImageSrcFromFilePath(logo?.login_icon_file_path),
    [logo?.login_icon_file_path],
  )
  useFavicon(Favicon || 'data:;base64,=')
  useEffect(() => {
    localStorage.setItem('active', active || '1')
  }, [active])

  return (
    <LoginContainer>
      <BgImg bgImage={LoginBg} onLoad={bgLoad}>
        {Logo !== '' && <img className="logo" alt="..." width={190} src={Logo} />}
        {logo?.on_off === 1 && (
          <p className="copyright">
            {logo?.copyright} {t('版权所有')}
          </p>
        )}
      </BgImg>
      {status === 'nothing' ? (
        <div className="spin">
          <Spin size="large" />
          <span className="loading">Loading</span>
        </div>
      ) : status === 'login' ? (
        <LoginForm>
          <div className="center">
            <div className="title">{t('登录')}</div>
            <div className="tabs">
              <Tab
                onClick={() => {
                  setActive('1')
                  setLoginStatus('direct-login')
                  localStorage.setItem('loginType', 'main-account')
                }}
                active={active === '1'}
              >
                <div className={active === '1' ? 'textActive' : 'textNormal'}>{t('主账号')}</div>
                <Line active={active === '1'} className="line" />
              </Tab>
              <Tab
                onClick={() => {
                  setActive('2')
                  setLoginStatus('sub-account')
                  localStorage.setItem('loginType', 'sub-account')
                }}
                active={active === '2'}
              >
                <div className={active === '2' ? 'textActive' : 'textNormal'}>{t('子账号')}</div>
                <Line active={active === '2'} className="line" />
              </Tab>
            </div>

            {loginStatus === 'direct-login' && (
              <DirectLogin loginType={'main-account'} setLoginStatus={setLoginStatus} />
            )}
            {loginStatus === 'forget-pwd' && <ForgetPwd setLoginStatus={setLoginStatus} />}
            {loginStatus === 'sub-account' && (
              <SubAccount loginType={'sub-account'} setLoginStatus={setLoginStatus} />
            )}
            {loginStatus === 'first-login' && (
              <FirstLogin setLoginStatus={setLoginStatus} setoldpassword={getoldpassword} />
            )}
            {loginStatus === 'first-reset-pwd' && (
              <FirstReset setLoginStatus={setLoginStatus} oldpassword={oldpassword} />
            )}
          </div>
          <img src={cubeImg} alt="" style={{ position: 'absolute', right: -20, top: 2 }} />
        </LoginForm>
      ) : status === 'auth' ? (
        <LoginForm>
          <div className="center">
            <SvgIcon name={'notLogin'} width={'184px'} height={'132px'} className="item1" />
            <div
              style={{ fontWeight: 500, fontSize: 30, color: '#2090A8', margin: '60px 0 34px 0' }}
              className="item2"
            >
              {t('您的设备没有权限')}
            </div>
            <div style={{ color: '#333', fontSize: 20 }} className="item3">
              {t('如想继续使用服务，请联系商务续期')}
            </div>
            <div className="item4">
              {t('机器码：')}
              {authStatus?.machine_code || '-'}
            </div>
          </div>
          {/* <img src={cubeImg} alt="" style={{ position: 'absolute', right: -20, top: 2 }} /> */}
        </LoginForm>
      ) : (
        <LoginForm>
          <div className="center">
            <SvgIcon name={'notLogin'} width={'184px'} height={'132px'} className="item1" />
            <div
              style={{ fontWeight: 500, fontSize: 30, color: '#2090A8', margin: '60px 0 34px 0' }}
              className="item2"
            >
              {t('您的设备授权已过期')}
            </div>
            <div style={{ color: '#333', fontSize: 20 }} className="item3">
              {t('如想继续使用服务，请联系商务续期')}
            </div>
            <div className="item4">
              {t('机器码：')}
              {authStatus?.machine_code || '-'}
            </div>
          </div>
          {/* <img src={cubeImg} alt="" style={{ position: 'absolute', right: -20, top: 2 }} /> */}
        </LoginForm>
      )}
    </LoginContainer>
  )
}

const LoginContainer = styled.div`
  height: 100%;
  position: relative;
  display: flex;
  background: #dde1ff;

  .ant-spin-dot-item {
    background-color: #4238c9;
  }

  .spin {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    justify-content: center;
    margin: 0 auto;

    .loading {
      color: #4238c9;
    }
  }

  .logo {
    position: absolute;
    display: inline-block;
    max-width: 190px;
    max-height: 52px;
    height: auto;
    width: auto;
    /* overflow: hidden; */
    z-index: 99;
    margin: 34px 37px;
    object-fit: contain;
  }

  .copyright {
    position: absolute;
    bottom: 50px;
    font-size: 12px;
    color: #666666;
    line-height: 18px;
    word-break: break-all;
    word-wrap: break-word;
    width: 97%;
    text-align: center;
  }
`

const BgImg = styled.div<{ bgImage?: string }>`
  position: relative;
  align-items: flex-end;
  flex: 0.6;
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
  background-image: ${({ bgImage }) => (bgImage ? `url(${bgImage})` : 'none')};
  //height: 100%;
  //width: 100%;
  //min-height: 500px;
  //background-size: contain;
  //position: absolute;
  //top: 0;
  //left: 0;
`

const LoginForm = styled.div`
  position: absolute;
  right: 0px;
  z-index: 1;
  width: 42%;
  height: 100%;
  overflow: hidden;
  background: white;
  border-radius: 24px 0px 0px 24px;
  .center {
    width: 60%;
    margin: 100px auto;
  }
  .item1 {
    position: absolute;
    top: 220px; /*子元素顶部距离父元素顶部的距离为50% */
    left: 50%; /* 子元素左侧距离父元素左侧的距离为50% */
    transform: translate(-50%, -50%);
  }
  .item2 {
    position: absolute;
    top: 295px; /*子元素顶部距离父元素顶部的距离为50% */
    left: 50%; /* 子元素左侧距离父元素左侧的距离为50% */
    transform: translate(-50%, -50%);
  }
  .item3 {
    position: absolute;
    width: 320px;
    top: 411px; /*子元素顶部距离父元素顶部的距离为50% */
    left: 50%; /* 子元素左侧距离父元素左侧的距离为50% */
    transform: translate(-50%, -50%);
  }
  .item4 {
    position: absolute;
    top: 450px; /*子元素顶部距离父元素顶部的距离为50% */
    left: 50%; /* 子元素左侧距离父元素左侧的距离为50% */
    transform: translate(-50%, -50%);
  }
  .title {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    line-height: 45px;
  }
  .textActive {
    color: #4238c9;
  }
  .textNormal {
    color: #333333;
  }
  .tabs {
    font-weight: bold;
    font-size: 20px;
    display: flex;
    margin-bottom: 40px;
  }
  .logo-box {
    width: 200px;
    height: 140px;
    margin-top: 10px;
    display: flex;
    align-items: center;
  }
`
const Tab = styled.div`
  color: ${props => (props.active ? '#4238C9' : '#333333')};
  display: flex;
  line-height: 30px;
  margin-right: 20px;
  margin-top: 42px;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
`

const Line = styled.div`
  width: 20px;
  height: 4px;
  border-radius: 2px;
  background: ${props => (props.active ? '#4238C9' : '')};
`

export default Login
